export enum PALETTE {
  BLURPLE = '#5e02f4',
  PURPLE = '#ba0bff',
}
